import { inject } from '@angular/core';
import { HttpContextToken, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { CoreProvider } from '../core.provider';

export const CUSTOM_REQUEST_AUTHORIZATION = new HttpContextToken<string>(() => '');

export function apiAuthInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  let authHeader = req.context.get(CUSTOM_REQUEST_AUTHORIZATION);
  if (authHeader === CUSTOM_REQUEST_AUTHORIZATION.defaultValue()) {
    const core = inject(CoreProvider);
    if (core.auth.isAuthenticated) {
      authHeader = core.auth.liveTokens?.accessToken ? `Bearer ${core.auth.liveTokens?.accessToken}` : 'INVALID_SESS_STATE';
    }
  }

  return next(req.clone({
    setHeaders: authHeader ? { Authorization: authHeader } : {}
  }));
}
